import { createSlice } from "@reduxjs/toolkit";

import axios from "axios";


const initialState={
    loading:false,
    Alldata:null
}


export const AnalyticsFormSlice=createSlice({
    name:"AnalyticsSlice",
    initialState,
    reducers:{

        AnalyticsStart: (state)=>{
            state.loading=true
            state.Alldata=null
        },
        AnalyticsSuccess: (state,action)=>{
            state.loading=false
            state.Alldata=action.payload

        },
        AnalyticsFail: (state,action)=>{
            state.loading=false
            state.Alldata=null

        }


    }
})


export const {AnalyticsStart,AnalyticsSuccess,AnalyticsFail}=AnalyticsFormSlice.actions

//userId Admin ka rahega

export const AnalyticsFormFunc=(FormId,userId)=>(dispatch)=>{
    
    
let url='http://18.132.190.48:8080/api/v1'
dispatch(AnalyticsStart())

    return axios
    .get(`${url}/analytics/get/${FormId}?userId=${userId}`)
    .then((res)=>{
        dispatch(AnalyticsSuccess(res))
    })
    .catch((err)=>{
       dispatch(AnalyticsFail(err))
    })




    

}


export default AnalyticsFormSlice.reducer